export default __webpack_public_path__ + "static/media/GalleryFirstSEFullSize.3cdc07ef.jpg";